// extracted by mini-css-extract-plugin
export var arrowContainer = "lpCompetitorSection-module--arrowContainer--4b70e";
export var cardContainer = "lpCompetitorSection-module--cardContainer--de067";
export var col = "lpCompetitorSection-module--col--dbe59";
export var col1 = "lpCompetitorSection-module--col1--e922c";
export var col2 = "lpCompetitorSection-module--col2--da36b";
export var col3 = "lpCompetitorSection-module--col3--fb822";
export var container = "lpCompetitorSection-module--container--907e6";
export var label = "lpCompetitorSection-module--label--5f02a";
export var logo = "lpCompetitorSection-module--logo--91720";
export var row = "lpCompetitorSection-module--row--b5d51";
export var secondaryLogo = "lpCompetitorSection-module--secondaryLogo--16159";
export var secondaryLogoImage = "lpCompetitorSection-module--secondaryLogoImage--bdff1";
export var singleColumn = "lpCompetitorSection-module--singleColumn--e1982";
export var textContainer = "lpCompetitorSection-module--textContainer--6863e";